import { Link } from 'react-router-dom';
import Logo from '../../assets/images/logo/logo-icon.svg';
import DarkModeSwitcher from './header/DarkModeSwitcher';
import DropdownMessage from './header/DropdownMessage';
import DropdownNotification from './header/DropdownNotification';
import DropdownUser from './header/DropdownUser';
import { LOGO, LOGO_DARK } from '../../config';
import { useDarkMode } from '../../rdxsga/hooks/common/useDarkMode';
import { useDropdownApi } from '../../rdxsga/hooks/actions/dropdown/useDropdownApi';
import { useSelector } from 'react-redux';
import { dropdownSelector } from '../../rdxsga/redux/slices/commonDropdownSlice';
import { useEffect, useState } from 'react';
import { IconButton } from '@material-tailwind/react';
import { AiOutlineMenu, AiOutlineMenuFold, AiOutlineMenuUnfold } from 'react-icons/ai';
import { conversationUsersListSelector } from '../../rdxsga/redux/slices/adminListSlice';
import { useUserApi } from '../../rdxsga/hooks/actions/users/useUserApiHook';
import moment from 'moment';


const Header = ({
  sidebarOpen,
  setSidebarOpen,
  handleLogout,
  openDrawerRight,

}) => {
  const darkMode = useDarkMode();

  const dropdownApi = useDropdownApi();
  const userApi = useUserApi();
  const { gettingDropdown, countryData } = useSelector(dropdownSelector)
  const conversationUsers = useSelector(conversationUsersListSelector)


  const [currentTime, setCurrentTime] = useState(moment().format('DD MMM, YYYY - hh:mm A'));

  useEffect(() => {
    let time = 0;
    const interval = setInterval(() => {
      setCurrentTime(moment().format('DD MMM, YYYY - hh:mm a').replace(":", time++ % 2 === 0 ? ":" : " "));
    }, 1000);
    return () => clearInterval(interval);
  }, []);



  // //console.log(gettingDropdown, countryData)
  useEffect(() => {
    if (countryData.length === 0) {
      dropdownApi.fetchDropdownData({}, (message, resp) => {
        // //console.log(message)
      }, (message, resp) => {
        // //console.log(message);
      })
    }
  }, [countryData])


  useEffect(() => {
    if (conversationUsers.length === 0) {
      userApi.allConversationsUsers({}, (msg, resp) => { }, (msg, resp) => { })
      //console.log({ conversationUsers })
    }

  }, [conversationUsers])


  return (
    <header className={`sticky top-0 z-999 flex w-full bg-white drop-shadow-1 dark:bg-boxdark dark:drop-shadow-none`}>
      <div className="w-full flex flex-grow items-center justify-between py-1 px-4 shadow-2 md:px-6 2xl:px-11">
        <IconButton
          variant='text'
          onClick={() => setSidebarOpen(!sidebarOpen)}
          className={`p-0 ${sidebarOpen || "ml-[50px]"} `}
        >
          {
            sidebarOpen ? <AiOutlineMenuFold color='amber' size={20} /> : <AiOutlineMenuUnfold color='amber' size={20} />
          }
        </IconButton>
        {/* <img src={LOGO} alt="Logo" className='h-8' /> */}
        <div>

        </div>
        {
          process.env.REACT_APP_ENVIRONMENT != "prod" && <div className="flex items-center gap-4 2xsm:gap-7">
            <div className="flex items-center gap-1">
              <span className="text-xs font-light" variant="small">
                {currentTime}
              </span>
            </div>
          </div>
        }

        <div className="flex items-center gap-3 2xsm:gap-7">
          <DropdownUser handleLogout={handleLogout} openDrawerRight={openDrawerRight} />
        </div>
      </div>
    </header>
  );
};

export default Header;
